const reserveMixin = {
  
  methods: {
    // 日予約か時間予約を判定
    isReserveDay: function() {
      return (!this.unit || 0 <= this.unit.lastIndexOf('1日')) ? true : false;
    },
    // フリースペースの判定
    isFree: function() {
      return this.plan == "free" ? true : false;
    },
    // 会議室の判定
    isConference: function() {
      return this.plan == "conference" ? true : false;
    },
    // 大広間の判定
    isHall: function() {
      return this.plan == "hall" ? true : false;
    },
    // ストアに予約情報が存在しない場合、予約一覧画面へ遷移
    transitionRoomList: function() {
      if (!this.item || !this.reserveDate || !this.reserveFromTime
        || !this.reserveToTime || !this.personNum) {
        // ストアに情報が存在しない場合は予約一覧画面へ遷移
        this.$router.push({ name: 'roomList' });
      }
    },
  },
  computed: {
    email: function() {
      return this.$store.getters.email;
    },
    token: function() {
      return this.$store.getters.token;
    },
    item: function() {
      return this.$store.getters.item;
    },
    plan: function() {
      return this.$store.getters.item.plan;
    },
    unit: function() {
      return this.$store.getters.item.unit;
    },
    reserveDate: function() {
      return this.$store.getters.reserveDate;
    },
    reserveFromTime: function() {
      return this.$store.getters.reserveFromTime;
    },
    reserveToTime: function() {
      return this.$store.getters.reserveToTime;
    },
    personNum: function() {
      return this.$store.getters.personNum;
    },
    visiters: function() {
      return this.$store.getters.visiters;
    },
    memo: function() {
      return this.$store.getters.memo;
    },
  }
}

export default reserveMixin;